import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';
import {
  PILL_CONTROL,
  saveGeneralInsightsPreferences,
  getSegmentationData,
} from '@bingads-webui-campaign-react/competition-core';

const preferencesService = globalContext.requireDefault('component/preference/service/index');
const appState = globalContext.require('component/state/index');
const { getSegType } = globalContext.require('component/bingads-grid/service/segmentation-preferences');

export const pillControlPlugin = defineGridPlugin(
  'pillControl',
  [
    'gridView',
    'config',
    'toolbar',
    'segment',
  ],
  (gridView, config, toolbar, segment) => {
    const menuId = 'summary-overtime';
    const type = [PILL_CONTROL.overtime, PILL_CONTROL.summary];
    const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(menuId);
    const pluginConfig = _.result(config.plugins, 'pillControl', {});
    const {
      i18n,
      segmentationTypesCollection,
    } = pluginConfig;
    const {
      currentActivity,
    } = config;

    function updateSegmentMenu(selectedIndex) {
      toolbarEditor.update(getMenu(selectedIndex)); // eslint-disable-line no-use-before-define
      const segmentationTypes = segmentationTypesCollection[selectedIndex];
      let newSegType = getSegmentationData({
        activity: currentActivity,
        appState,
        getSegType,
        preferencesService,
      });

      currentActivity.trace(`use segment type ${newSegType}`, 'pillControlPlugin');
      if (!_.contains(segmentationTypes, newSegType) && newSegType !== 'None') {
        newSegType = 'None';
        currentActivity.error(`${newSegType} doesn't exist, fall back to None`, 'pillControlPlugin');
      }
      segment.setSegmentType(newSegType, segmentationTypes);
    }

    function getMenu(selectedIndex) {
      return {
        type: 'pill-control',
        id: menuId,
        items: [{
          text: i18n.getString('Over_Time'),
        }, {
          text: i18n.getString('Summary'),
        }],
        selectedIndex,
        onClick(index) {
          if (index !== this.selectedIndex) {
            const menuName = type[index];

            saveGeneralInsightsPreferences({ pillControlType: menuName }, preferencesService);
            currentActivity.trace(`click ${menuName} menu `, 'pillControlPlugin');
            updateSegmentMenu(index);
            gridView.refresh(true);
          }
        },
      };
    }

    const pillControlTypeInPreference = _.chain({})
      .defaults(config.query)
      .result('query')
      .result('PillControlType', PILL_CONTROL.overtime)
      .value();
    let defaultIndex = 0;

    defaultIndex = _.indexOf(type, pillControlTypeInPreference);
    updateSegmentMenu(defaultIndex);
  }
);

